import React, { useState, useEffect } from "react";
import {} from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import Modal from "react-bootstrap/Modal";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useButtonLoader from "../../hooks/useButtonLoader";
import { Url } from "../../config/config";

export default function Banner() {
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [inputField, setInputField] = useState({
    id: "",
    name: "",
    profile: "",
    description: "",
    desination: "",
  });

  const [errorField, setErrorField] = useState({
    name: "",
    profile: "",
    description: "",
    desination: "",
  });

  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );

  //handle delete
  const [DeleteModal, setDeleteModal] = useState(false);
  const handelDeleteShow = (id) => {
    //console.log(id);
    setDeleteModal(true);
    setInputField({ ...inputField, id: id });
  };
  const handelDeleteClose = () => {
    setDeleteModal(false);
  };

  const handelDelete = async () => {
    try {
      const res = await axios({
        url: `${Url}/testimonial/delete/${inputField.id}`,
        method: "DELETE",
      });
      if (res.data.status === 200) {
        handelDeleteClose();
        toast.success(res.data.message);
        testimonialList(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //***********Block UnBlock*************** */
  const [BlockModal, setBlockModal] = useState(false);
  const handelBlockShow = () => {
    setBlockModal(true);
  };

  const handelBlockClose = () => {
    setBlockModal(false);
  };
  const handleChecked = (e, id) => {
    handelBlockShow();
    setInputField({
      ...inputField,
      status: e.target.checked,
      id: id,
    });
  };

  const handelUpdateStatus = async () => {
    try {
      console.log(inputField);
      const res = await axios({
        url: `${Url}/testimonial/change_status`,
        method: "POST",
        data: {
          id: inputField.id,
          status: inputField.status,
        },
      });
      console.log(res);
      if (res.data.status === 200) {
        handelBlockClose();
        toast.success(res.data.message);
        testimonialList(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //***************Add Banner *********** */
  const [AddModal, setAddModal] = useState(false);
  const handelAddModalShow = () => {
    setInputField("");
    setErrorField("");
    setAddModal(true);
  };

  const handelAddModalClose = () => {
    setAddModal(false);
  };

  //*************Input Onchange***** */
  const handelInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputField({
      ...inputField,
      [name]: value,
    });
  };

  //**************Handel Image ********** */
  const handelImageOnchange = (e) => {
    setInputField({
      ...inputField,
      profile: e.target.files[0],
      preview: URL.createObjectURL(e.target.files[0]),
    });
  };

  //*************Handel Validation************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!inputField.name) {
      errorField["name"] = "Name field is required";
      formIsValid = false;
    }
    if (!inputField.description) {
      errorField["description"] = "Description field is required";
      formIsValid = false;
    }

    if (!inputField.desination) {
      errorField["desination"] = "Designation field is required";
      formIsValid = false;
    }
    if (!inputField.profile) {
      errorField["profile"] = "Profile image field is required";
      formIsValid = false;
    }
    setErrorField(errorField);
    setSubmitLoading(false);
    return formIsValid;
  };

  //*************Handel Submit*************** */
  const handelSubmit = async () => {
    try {
      setSubmitLoading(true);
      if (handleValidation()) {
        let res = await axios({
          url: `${Url}/testimonial/add`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          data: inputField,
        });
        setSubmitLoading(false);
        if (res.data.status === 200) {
          handelAddModalClose();
          setInputField("");
          setErrorField("");
          testimonialList(activePage);
          toast.success(res.data.message);
        } else if (res.data.status === 419) {
          toast.error(res.data.message);
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //*************Handel Edit *************** */
  const [EditModal, setEditModal] = useState(false);
  const handelEditModalClose = () => {
    setEditModal(false);
  };
  const handelEditModalShow = (data) => {
    setEditModal(true);
    setInputField({ ...data, id: data._id });
  };
  const handelEditSubmit = async () => {
    try {
      setSubmitLoading(true);
      const res = await axios({
        url: `${Url}/testimonial/update`,
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        data: inputField,
      });
      setSubmitLoading(false);
      if (res.data.status === 200) {
        handelEditModalClose();
        testimonialList(activePage);
        toast.success(res.data.message);
      } else if (res.data.status === 419) {
        toast.error(res.data.message);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const testimonialList = async (page = 1, query = "") => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/testimonial/list?page=${page}&search=${query}`,
        method: "GET",
        headers: {
          //Authorization: "Bearer " + accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();

      if (res.data.status === 200) {
        setRecord(res.data.data.testimoniallist);
        setTotal(res.data.data.total);
      }
    } catch (err) {
      console.log(err);
    }
    // console.log(res.data.result);
  };

  useEffect(() => {
    testimonialList(activePage);
    // eslint-disable-next-line
  }, []);

  //*********Handel Search************** */
  const handelSearch = (e) => {
    //setSearch(e.target.value);
    testimonialList(activePage, e.target.value);
    // console.log(e.target.value);
  };

  //***********Handel pagination*********** */
  const handlePageChange = (pageNo) => {
    setActivePage(pageNo);
    testimonialList(pageNo);
  };

  var count = (activePage - 1) * 10 + 1;

  return (
    <React.Fragment>
      <title>Testimonials</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />

              <button
                className="button py-auto"
                type="button"
                onClick={handelAddModalShow}
              >
                Add&nbsp;Testimonials
              </button>
            </div>
            <h4 className="Title">Testimonials</h4>
            {loader}
            <div className="TableList">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Designation</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((item, i) => (
                      <tr key={i}>
                        <td>{count++}</td>

                        <td>
                          {item.image ? (
                            <img
                              src={item.image}
                              height="50"
                              width="50"
                              alt={item.name}
                            />
                          ) : (
                            ""
                          )}
                        </td>
                        <td>{item.name}</td>
                        <td>{item.description}</td>
                        <td>{item.desination}</td>
                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="status"
                              checked={item.status}
                              onChange={(e) => handleChecked(e, item._id)}
                            />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          <span
                            className="Green inline-block"
                            onClick={(e) => handelEditModalShow(item)}
                          >
                            <i className="fa fa-edit"></i>
                          </span>

                          <span
                            className="Red inline-block"
                            onClick={(e) => handelDeleteShow(item._id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="ModalBox">
        {/* Add modal */}
        <Modal
          show={AddModal}
          // style={{ opacity: 1 }}
          onHide={handelAddModalClose}
        >
          <Modal.Header closeButton onClick={handelAddModalClose}>
            <Modal.Title>Add New Testimonial</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Name"
                  name="name"
                  value={inputField.name}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.name}
                </span>
              </div>
              <div className="form-group">
                <label>Designation</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Designation"
                  name="desination"
                  value={inputField.desination}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.desination}
                </span>
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Enter Description"
                  name="description"
                  value={inputField.description}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.description}
                </span>
              </div>
              <div className="form-group">
                <div className="upload_image">
                  <label htmlFor="banner-img">
                    <span>Profile Image</span>
                    <i className="fa fa-upload"></i>
                  </label>
                  <input
                    id="banner-img"
                    type="file"
                    className="form-control"
                    name="profile"
                    onChange={(e) => {
                      handelImageOnchange(e);
                    }}
                  />
                  <span style={{ color: "red" }} className="error">
                    {errorField.profile}
                  </span>
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button variant="secondary" onClick={handelAddModalClose}>
              Close
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelSubmit}
              ref={submitButtonElement}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
        {/* End add Modal */}

        {/* Edit modal */}
        <Modal
          show={EditModal}
          // style={{ opacity: 1 }}
          onHide={handelEditModalClose}
        >
          <Modal.Header closeButton onClick={handelEditModalClose}>
            <Modal.Title>Edit Testimonial</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Name"
                  name="name"
                  value={inputField.name}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.name}
                </span>
              </div>
              <div className="form-group">
                <label>Designation</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Designation"
                  name="desination"
                  value={inputField.desination}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.desination}
                </span>
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Enter Description"
                  name="description"
                  value={inputField.description}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.description}
                </span>
              </div>
              <div className="form-group">
                <div className="upload_image">
                  <label htmlFor="bannerImg">
                    <span>Profile Image </span>
                    <i className="fa fa-upload"></i>
                  </label>
                  <input
                    id="bannerImg"
                    type="file"
                    className="form-control"
                    name="profile"
                    onChange={(e) => {
                      handelImageOnchange(e);
                    }}
                  />

                  {inputField.preview ? (
                    <img
                      src={inputField.preview}
                      height="40"
                      width="40"
                      alt={inputField.preview}
                    />
                  ) : (
                    <img
                      src={inputField.image}
                      height="40"
                      width="40"
                      alt={inputField.name}
                    />
                  )}
                </div>
                {/* <span style={{ color: "red" }} className="error">
                  {errorField.banner}
                </span> */}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            {/* <button variant="secondary" onClick={handelEditModalClose}>
              Close
            </button> */}
            <button
              className="primary"
              variant="primary"
              onClick={handelEditSubmit}
              ref={submitButtonElement}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
        {/* End edit Modal */}

        {/* Start Delete Modal */}
        <Modal
          show={DeleteModal}
          //style={{ opacity: 1 }}
          onHide={handelDeleteClose}
        >
          <Modal.Header closeButton onClick={handelDeleteClose}>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to delete this testimonial?</Modal.Body>
          <Modal.Footer>
            <button
              className="primary"
              variant="secondary"
              onClick={handelDeleteClose}
            >
              No
            </button>
            <button
              className="secondary"
              variant="primary"
              onClick={handelDelete}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* End delete Modal */}

        {/* block or unblock model */}
        <Modal show={BlockModal} onHide={handelBlockClose}>
          <Modal.Header closeButton onClick={handelBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handelBlockClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelUpdateStatus}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* end block unblock modal */}
      </div>
    </React.Fragment>
  );
}
